var OverrideNoteDetail = /** @class */ (function () {
    function OverrideNoteDetail(candidateId) {
        this.candidateId = candidateId;
        this.firstName;
        this.lastName;
        this.recruiterEmail;
        this.overrideNote;
    }
    return OverrideNoteDetail;
}());
export { OverrideNoteDetail };
//# sourceMappingURL=overrideNoteDetail.js.map